export const LocalStorage = {
    TOKEN: "token",
    COMPANY_ID: "companyId",
    CURRENT_USER: "currentUser",
    USERNAME:"userName",
    PASSWORD:"password",
    PROFILE:"profile",
    ISCHANGEPASSWORDOPENED:"passwordChangePopupOpenend",
    MAIN_USER:"mainUser",
    ISAPPROVER:"isApprover"
}